import React from "react";

function ViewDepartment({ data }) {
  const formatDateTime = (date) => {
    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\//g, "-")
      .replace(",", "");
  };

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-6 mb-3">
          <strong>Department Name</strong>
          <p>{data?.name || "-"}</p>
        </div>

        <div className="col-md-6 mb-3">
          <strong>Status</strong>
          <p>
            <span
              className={`badge ${
                data?.status === 1 ? "bg-success" : "bg-danger"
              }`}
            >
              {data?.status === 1 ? "Active" : "Inactive"}
            </span>
          </p>
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Created At</label>
          <input
            type="text"
            className="form-control"
            disabled
            value={data?.created_at ? formatDateTime(data.created_at) : "-"}
            readOnly
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Updated At</label>
          <input
            type="text"
            className="form-control"
            disabled
            value={data?.updated_at ? formatDateTime(data.updated_at) : "-"}
            readOnly
          />
        </div>
      </div>
    </div>
  );
}

export default ViewDepartment;